<script>
import Swal from "sweetalert2";
import moment from "moment";
import Drawer from "@/components/drawer.vue";

// Custom Components
import DeviceProfile from "@/components/superAdmin/deviceProfile.vue";
import PageHeader from "@/components/page-header";
import pbxService from "@/helpers/APIService/pbx.service";
import middlewares from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    DeviceProfile,
  },
  data() {
    return {
      title: "Device Profile",
      deviceProfileList: [],
      deviceProfileId: null,
      isShowDeviceProfileForm: false,
      isLoading: false,
      isEdit: false,
      isMounted: true,
      isFilterLoading: false,
      filter: {
        model: "",
        vendor: "",
        type: "",
      },
      models: [],
      isFilterApply: false,
      baseQuery: "",
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getDeviceProfileList();
  },
  methods: {
    // Method is use for get app feature list
    async getDeviceProfileList(query) {
      this.isLoading = true;
      try {
        const response = await pbxService.getDeviceProfileList(
          query ? query : ""
        );
        if (response) {
          this.deviceProfileList = response.result;
        }
        if (this.isMounted) {
          response.result.forEach((element) => {
            if (!this.models.includes(element.model)) {
              this.models.push(element.model);
            }
          });
        }
        this.isLoading = false;
        this.isFilterLoading = false;
      } catch (error) {
        errorHandler(error);
        this.isLoading = false;
        this.isFilterLoading = false;
      }
    },
    async filterApply(proccess) {
      this.isMounted = false;
      if (proccess == "clear") {
        if (this.baseQuery != "") {
          this.isFilterLoading = true;
          await this.getDeviceProfileList("");
          this.baseQuery = "";
        }
        this.isFilterApply = false;
        this.filter.model = "";
        this.filter.vendor = "";
        this.filter.type = "";
      } else {
        let isFirstFilterAssing = false;
        this.isFilterApply = true;
        this.baseQuery = "";
        if (this.filter.model !== "") {
          !isFirstFilterAssing
            ? (this.baseQuery += `?model=${this.filter.model}`)
            : (this.baseQuery += `&model=${this.filter.model}`);
          isFirstFilterAssing = true;
        }
        if (this.filter.vendor !== "") {
          !isFirstFilterAssing
            ? (this.baseQuery += `?vendor=${this.filter.vendor}`)
            : (this.baseQuery += `&vendor=${this.filter.vendor}`);
          isFirstFilterAssing = true;
        }
        if (this.filter.type !== "") {
          !isFirstFilterAssing
            ? (this.baseQuery += `?type=${this.filter.type}`)
            : (this.baseQuery += `&type=${this.filter.type}`);
          isFirstFilterAssing = true;
        }
        if (isFirstFilterAssing && this.baseQuery !== "") {
          this.isFilterLoading = true;
          await this.getDeviceProfileList(this.baseQuery);
        }
      }
    },
    editDeviceProfile(device_profile_id) {
      this.deviceProfileId = device_profile_id;
      this.deviceProfileForm();
      this.isEdit = true;
    },
    deviceProfileForm() {
      this.isShowDeviceProfileForm = !this.isShowDeviceProfileForm;
    },
    handleSubmit(data) {
      if (this.isEdit) {
        this.deviceProfileList = this.deviceProfileList.map((item) => {
          if (item.id == data.id) {
            item = data;
          }
          return item;
        });
      } else {
        this.deviceProfileList.push(data);
      }
      this.deviceProfileForm();
      this.isEdit = false;
    },
    handleCancel() {
      this.isEdit = false;
      this.deviceProfileForm();
    },
    deleteDeviceProfile(device_profile_id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            await pbxService.deleteDeviceProfileDetail(device_profile_id);
            this.deviceProfileList.splice(index, 1);
            middlewares.notification("Deleted successfully !!", "danger");
          } catch (error) {
            errorHandler(error);
          }
        }
      });
    },
    convertTime(date) {
      return moment(date).format("YYYY-MM-DD / hh:mm A");
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="deviceProfileForm"
      text="Add New Device Profile"
      :isButton="true"
    />
    <b-card>
      <div class="row">
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <select
            name="is_active"
            id="is_active"
            class="form-control mb-2"
            v-model="filter.model"
            placeholder="Domain active status"
          >
            <option value="">Select Model</option>
            <option
              v-for="(model, index) in models"
              :key="index"
              :value="model"
            >
              {{ model }}
            </option>
          </select>
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <input
            type="text"
            class="form-control mb-2"
            placeholder="Search by vendor"
            v-model="filter.vendor"
          />
        </div>
        <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <input
            type="text"
            class="form-control mb-2"
            placeholder="Search by device type"
            v-model="filter.type"
          />
        </div>
        <div class="col-xl-2 col-lg-3 col-md-2">
          <button
            class="btn btn-primary float-end float-lg-start mb-2 me-2"
            @click="filterApply('apply')"
            :disabled="isFilterLoading"
          >
            Apply Filter
          </button>
          <button
            class="btn btn-primary float-end float-lg-start mb-2"
            @click="filterApply('clear')"
            :disabled="isFilterLoading"
          >
            Clear Filter
          </button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table mb-0" :data="deviceProfileList">
          <thead class="table-light" slot="head">
            <tr>
              <th>Model</th>
              <th>Vendor</th>
              <th>Template</th>
              <th>Line</th>
              <th>Type</th>
              <th>Created At</th>
              <th>Created By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 8" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              v-for="(deviceProfile, index) in deviceProfileList"
              :key="index"
            >
              <td @click="editDeviceProfile(deviceProfile.id)">
                {{ deviceProfile.model }}
              </td>
              <td @click="editDeviceProfile(deviceProfile.id)">
                {{ deviceProfile.vendor }}
              </td>
              <td @click="editDeviceProfile(deviceProfile.id)">
                {{ deviceProfile.template }}
              </td>
              <td @click="editDeviceProfile(deviceProfile.id)">
                {{ deviceProfile.line }}
              </td>
              <td @click="editDeviceProfile(deviceProfile.id)">
                {{ deviceProfile.type }}
              </td>
              <td @click="editDeviceProfile(deviceProfile.id)">
                {{
                  deviceProfile.created_at
                    ? convertTime(deviceProfile.created_at)
                    : "-"
                }}
              </td>
              <td @click="editDeviceProfile(deviceProfile.id)">
                {{ deviceProfile.created_by ? deviceProfile.created_by : "-" }}
              </td>
              <td>
                <i
                  class="fas fa-pencil-alt text-success"
                  v-b-popover.hover="'Edit'"
                  @click="editDeviceProfile(deviceProfile.id)"
                ></i>
                <i
                  class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                  v-b-popover.hover="'Delete'"
                  @click="deleteDeviceProfile(deviceProfile.id, index)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
    <Drawer
      @close="handleCancel"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="800"
    >
      <div v-if="isShowDeviceProfileForm">
        <DeviceProfile
          :deviceProfileId="this.deviceProfileId"
          :isEdit="this.isEdit"
          @cancelSubmit="handleCancel"
          @submitted="handleSubmit"
        />
      </div>
    </Drawer>
  </div>
</template>
